<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_3"></a>Dedicated to boys everywhere, young and old.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04dedication.vue?7af65272